const ConditionalWrapper = ({
  condition,
  wrapper,
  alternateWrapper = null,
  children,
}) => {
  return condition
    ? wrapper(children)
    : alternateWrapper
    ? alternateWrapper(children)
    : children;
};

export default ConditionalWrapper;
